import React from 'react'
import './about.css'
import ME from '../../assets/about_me.jpg'
import {FaAward} from 'react-icons/fa'
import {FiUser} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'

const About = () => {
  return (
    <section id='about'>
      <h5>Get To Know</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
          <div className="about__me-image">
            <img src={ME} alt="About Rachmat" />
          </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className='about__card'>
              <FaAward className= 'about__icon'/>
              <h5>Official Notion Certifications</h5>
              <small>3</small>
            </article>

            <article className='about__card'>
              <FiUser className= 'about__icon'/>
              <h5>All Product Downloads</h5>
              <small>1500+</small>
            </article>

            <article className='about__card'>
              <VscFolderLibrary className= 'about__icon'/>
              <h5>Templates</h5>
              <small>90+</small>
            </article>
          </div>

          <p>
          Hi, I'm a digital workspace architect specializing in advanced Notion operating systems. I have combined my background in clean design and database engineering to build high-performance, minimalist templates that help solopreneurs, creators, and academics turn digital chaos into streamlined execution. I don't just build layouts; I engineer frictionless workflows.
          </p>

          <a href="#contact" className='btn btn-primary'>Let's Talk</a>
        </div>
      </div>
    </section>
  )
}

export default About
